"use client";

import Link from "next/link";

const ContribuerPage = () => {
  return (
    <main className="container mx-auto px-4 py-12">
      <h1 className="text-center text-4xl font-bold text-gray-900 dark:text-white">
        Contribuer à "Les Concernés"
      </h1>
      <p className="mt-2 text-center text-gray-600 dark:text-gray-300">
        Rejoignez notre équipe de contributeurs et participez à l’analyse du
        monde d’aujourd’hui.
      </p>

      <section className="mx-auto mt-10 max-w-3xl rounded-lg bg-white p-6 shadow dark:bg-gray-800">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
          Pourquoi écrire pour Les Concernés ?
        </h2>
        <p className="mt-4 text-gray-700 dark:text-gray-300">
          Comment écrire sur ou penser la Guinée – et par extension le continent
          africain – sans succomber à l’essentialisation et au sentimentalisme
          qui semblent aujourd’hui régner en maîtres incontestés sur différentes
          plateformes, de la télé aux réseaux sociaux ?
        </p>
        <p className="mt-4 text-gray-700 dark:text-gray-300">
          Tel est le principal défi que se lance le magazine{" "}
          <span className="font-semibold">Les Concernés</span>. Nous publions
          donc des articles d’analyses et des reportages de fond sur tous les
          sujets liés à l’Afrique ou à l’ordre actuel du monde, pourvu que
          l’écriture soit bonne et que l’analyse soit objective et solide.
        </p>
      </section>

      <section className="mx-auto mt-8 max-w-3xl rounded-lg bg-white p-6 shadow dark:bg-gray-800">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
          Comment devenir contributeur ?
        </h2>
        <p className="mt-4 text-gray-700 dark:text-gray-300">
          Pour être contributeur chez{" "}
          <span className="font-semibold">Les Concernés</span>, contactez-nous
          en envoyant votre article à notre rédaction.
        </p>
        <p className="mt-4 text-gray-700 dark:text-gray-300">
          Notre rédacteur en chef vous répondra dans un délai de{" "}
          <span className="font-semibold">2 à 7 jours</span>, en fonction de
          l’urgence du sujet dont vous traitez et de l’excellence de votre
          papier.
        </p>
      </section>

      <section className="mx-auto mt-8 max-w-3xl rounded-lg bg-white p-6 shadow dark:bg-gray-800">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
          Envoyez-nous votre article
        </h2>
        <p className="mt-4 text-gray-700 dark:text-gray-300">
          Vous pouvez nous envoyer votre proposition d’article à l’adresse
          suivante :
        </p>
        <p className="mt-2 font-semibold text-gray-900 dark:text-white">
          📧{" "}
          <Link
            href="mailto:contact@lesconcernes.com"
            className="text-blue-500 hover:underline"
          >
            contact@lesconcernes.com
          </Link>
        </p>
      </section>

      <section className="mt-8 text-center">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
          Vous avez des questions ?
        </h2>
        <p className="mt-2 text-gray-600 dark:text-gray-300">
          Contactez-nous et nous vous répondrons dans les plus brefs délais.
        </p>
        <Link href="/contact">
          <button className="mt-4 rounded-lg bg-blue-600 px-6 py-3 text-white hover:bg-blue-800">
            Nous contacter
          </button>
        </Link>
      </section>
    </main>
  );
};

export default ContribuerPage;
